module.exports = __webpack_public_path__ + "static/img/news_advertisement_01_zh.39483dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news_advertisement_01_zh.png
// module id = UiOr
// module chunks = 34